import {Component, EventEmitter, Input, Output, SimpleChanges} from "@angular/core";
import {CommonModule} from "@angular/common";
import {Project} from "../../interfaces/project";

interface Section {
  title: string;
  buttons: string[];
}

@Component({
  selector: 'app-project-form-nav',
  templateUrl: 'project-form-nav.component.html',
  standalone: true,
  imports: [CommonModule],
  styleUrl: 'project-form-nav.component.css'
})

export class ProjectFormNavComponent {
  @Input() formData!: Project;
  activeButton: string = '';
  @Output() stepSelected = new EventEmitter<number>();

  ngOnChanges(changes: SimpleChanges) {
    this.selectButton('School Summary');
  }

  sections: Section[] = [
    {
      title: 'Project Information',
      buttons: ['School Summary', 'Environmental Project Details', 'Environmental Project Categories']
    },
    {
      title: 'Results',
      buttons: ['Water Educational Campaign', 'Adopt-A-Road', 'Adopt-A-Stream Clean-up'
        ,'Adopt-A-Stream Monitoring', 'Stream Restoration/Erosion Control', 'GC&B Great Days of Service',
        'GC&B Wetland Cleanup',
        'Yellow River Trash Bash',
        'Shore Sweep',
        'Other Local Water-Related Event','Other Gwinnett County Service Dept',
        'Support Local Charity or Non-Profit', 'Waste Water Plant', 'Drinking Water Plant',
        'The Water Tower', 'Dept of Water Resources', 'Gwinnett Clean & Beautiful','Educational Campaign', 'Share Table', 'Composting', 'Food Pantry', 'Food Waste Audit',
      'Fish Hatchery', 'Chickens and Other Farm Animals', 'Outdoor Classroom/Gazebos/Seating',
      'Trails / Forested Area', 'Greenhouse', 'Composting System', 'Southeast Pollinator Census', 'Gardens', 'Hydroponics', 'Aquaponics',
      'Aeroponics', 'Grow Towers/systems', 'Paper & Cardboard', 'Textiles', 'Plastic (bottles, etc)',
      'Aluminum cans', 'Bring One for the Chipper - Christmas Tree Recycling', 'Earth day', 'America Recycles day',
      'Solar', 'Wind', 'Water', 'Other Recycle', 'Other Recycling Event']
    },
    {
      title: 'Support',
      buttons: ['Community Partners']
    },
  ];

  @Output() resultsExist = new EventEmitter<boolean>();

  isResultSelected(): boolean {
    const resultSteps = [
      25,26,27,28,29,30,31,32,33,34,36,37,38,39,40,41,42,43,
      44,45,46,47,48,49,50,51,52,53,54
    ];
    return this.activeSteps.some(step => resultSteps.includes(step));
  }

  activeSteps: number[] = [];

  @Output() stepToggled = new EventEmitter<number>();

  selectButton(name: string) {
    const step = this.sectionStepMap[name];
    if (step === undefined) return;

    const isCategory = step === 3;
    const resultSteps = [
      6, 7, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 25, 26, 27, 28, 29, 30, 31,
      32, 33, 34, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56
      ];
    const isResult = resultSteps.includes(step);

    if (isCategory) {
      const currentResults = this.activeSteps.filter(s => resultSteps.includes(s));
      if (this.activeSteps.includes(step)) {
        this.activeSteps = currentResults;
      } else {
        this.activeSteps = [...currentResults, step];
      }
    } else if (isResult) {
      const currentCategory = this.activeSteps.includes(3) ? [3] : [];
      const otherResults = this.activeSteps.filter(s => resultSteps.includes(s) && s !== step);
      if (this.activeSteps.includes(step)) {
        this.activeSteps = [...currentCategory, ...otherResults];
      } else {
        this.activeSteps = [...currentCategory, ...otherResults, step];
      }
    } else {
      this.activeSteps = [step];
    }
    this.stepToggled.emit(step);
  }

  shouldShow(btn: string): boolean {
    switch (btn) {
      case 'Water Educational Campaign':
        return !!this.formData?.waterEducationalCampaign;
      case 'Adopt-A-Road':
        return !!this.formData?.adoptARoadWatershed;
      case 'Adopt-A-Stream Clean-up':
        return !!this.formData?.adoptAStreamCleanup;
      case 'Adopt-A-Stream Monitoring':
        return !!this.formData?.adoptAStreamMonitoring;
      case 'Stream Restoration/Erosion Control':
        return !!this.formData?.streamRestoration;
      case 'GC&B Great Days of Service':
        return !!this.formData?.greatDaysService;
      case 'GC&B Wetland Cleanup':
        return !!this.formData?.wetlandCleanup;
      case 'Yellow River Trash Bash':
        return !!this.formData?.yellowRiverTrashBash;
      case 'Shore Sweep':
        return !!this.formData?.shoreSweep;
      case 'Other Local Water-Related Event':
        return !!this.formData?.localWaterEvent;
      case 'Other Gwinnett County Service Dept':
        return !!this.formData?.gwinnettServiceDept;
      case 'Support Local Charity or Non-Profit':
        return !!this.formData?.supportCharity;
      //case 'Other Student or School-Led Projects':
        //return !!this.formData?.studentProjects;
      case 'Waste Water Plant':
        return !!this.formData?.wasteWaterPlant;
      case 'Drinking Water Plant':
        return !!this.formData?.watersheddrinkingWaterPlant;
      case 'The Water Tower':
        return !!this.formData?.theWaterTower;
      case 'Dept of Water Resources':
        return !!this.formData?.deptOfWaterResources;
      case 'Gwinnett Clean & Beautiful':
        return !!this.formData?.gwinnettCleanBeautiful;
      case 'Educational Campaign':
        return !!this.formData?.educationalcampaign1;
      case 'Share Table':
        return !!this.formData?.sharetable1;
      case 'Composting':
        return !!this.formData?.compostingSelected;
      case 'Food Pantry':
        return !!this.formData?.pantry;
      case 'Food Waste Audit':
        return !!this.formData?.fwasteaudit;
      case 'Gardens':
        return !!this.formData?.outdoorSelected;
      case 'Fish Hatchery':
        return !!this.formData?.fish;
      case 'Chickens and Other Farm Animals':
        return !!this.formData?.chicken;
     case 'Outdoor Classroom/Gazebos/Seating':
      return !!this.formData?.class;
      case 'Trails / Forested Area':
        return !!this.formData?.trails;
      case 'Greenhouse':
        return !!this.formData?.greenhouse;
      case 'Composting System':
        return !!this.formData?.compostSystem;
        case 'Southeast Pollinator Census':
          return !!this.formData?.pollinatorCensus;
      case 'Hydroponics':
        return !!this.formData?.hydroponics1;
      case 'Aquaponics':
        return !!this.formData?.aquaponics1;
      case 'Aeroponics':
        return !!this.formData?.aeroponics1;
      case 'Grow Towers/systems':
        return !!this.formData?.towers1;
      case 'Paper & Cardboard':
        return !!this.formData?.paperAndCardboard;
      case 'Textiles':
        return !!this.formData?.textiles1;
      case 'Plastic (bottles, etc)':
        return !!this.formData?.plastics1;
      case 'Aluminum cans':
        return !!this.formData?.aluminumcans1;
      case 'Bring One for the Chipper - Christmas Tree Recycling':
        return !!this.formData?.chipperEvent;
      case 'Earth day':
        return !!this.formData?.earthDayEvent;
      case 'America Recycles day':
        return !!this.formData?.americaRecyclesEvent;
      case 'Solar':
        return !!this.formData?.solar1;
      case 'Wind':
        return !!this.formData?.wind1;
      case 'Water':
        return !!this.formData?.water1;
      case 'Other Recycle':
        return !!this.formData?.recycleOtherCheck;
      case 'Other Recycling Event':
        return !!this.formData?.recyclingEventsOtherCheck;
      default:
        return true;
    }
  }

  hasContent(section: Section, index: number): boolean {
    if (index === -1) return false;
    return section.buttons.some(btn => this.shouldShow(btn));
  }

  sectionStepMap: Record<string, number> = {
    'School Summary': 1,
    'Environmental Project Details': 2,
    'Environmental Project Categories': 3,
    'Community Partners': 4,
    'Food Waste': 5,
    'Composting': 6,
    'Gardens': 7,
    'Indoor Growing System': 8,
    'Recycling': 9,
    'Solar': 10,
    'Bring One for the Chipper - Christmas Tree Recycling': 11,
    'Share Table': 12,
    'Food Pantry': 13,
    'Food Waste Audit': 14,
    'Fish Hatchery': 15,
    'Chickens and Other Farm Animals': 16,
    'Outdoor Classroom/Gazebos/Seating': 17,
    'Trails / Forested Area': 18,
    'Paper & Cardboard': 19,
    'Educational Campaign': 20,
    'Greenhouse': 21,
    'Composting System': 22,
    'Southeast Pollinator Census': 23,
    'Water Education': 24,
    'Water Educational Campaign': 25,
    'Adopt-A-Road': 26,
    'Adopt-A-Stream Clean-up': 27,
    'Adopt-A-Stream Monitoring': 28,
    'Stream Restoration/Erosion Control': 29,
    'Waste Water Plant': 30,
    'Drinking Water Plant': 31,
    'The Water Tower': 32,
    'Dept of Water Resources': 33,
    'Gwinnett Clean & Beautiful': 34,
    'Watershed Field Trip Other': 35,
    'GC&B Great Days of Service': 36,
    'GC&B Wetland Cleanup': 37,
    'Yellow River Trash Bash': 38,
    'Shore Sweep': 39,
    'Other Local Water-Related Event': 40,
    'Other Gwinnett County Service Dept': 41,
    'Support Local Charity or Non-Profit': 42,
    //'Other Student or School-Led Projects': 43,
    'Hydroponics': 44,
    'Aquaponics': 45,
    'Aeroponics': 46,
    'Grow Towers/systems': 47,
    'Textiles': 48,
    'Plastic (bottles, etc)': 49,
    'Aluminum cans': 50,
    'Earth day': 51,
    'America Recycles day': 52,
    'Wind': 53,
    'Water': 54,
    'Other Recycle': 55,
    'Other Recycling Event': 56
  };
}
